import { render, staticRenderFns } from "./Lesson.vue?vue&type=template&id=51986910&scoped=true"
import script from "./Lesson.vue?vue&type=script&lang=js"
export * from "./Lesson.vue?vue&type=script&lang=js"
import style0 from "./Lesson.vue?vue&type=style&index=0&id=51986910&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51986910",
  null
  
)

export default component.exports